import quickSpecs from './quickSpecs';
import vehicleType from './vehicleType';
import quickSpecsIDC from './quickSpecsIDC';

const root = {
	quickSpecs,
	vehicleType,
	quickSpecsIDC
};

export default root;
